export type NotifyRequest = {
  slug: string
  email: string
}

export const submitNotifyRequest = async (
  request: NotifyRequest,
): Promise<NotifyRequest> => request
